import { Box, Checkbox, Flex, Stack, Text } from '@chakra-ui/react'

import { FormField } from '../../../../components/FormField'
import { Icon } from '../../../../components/Icon'
import { Tooltip } from '../../../../components/Tooltip'
import { TTransportBenefit } from '../../../../services/Admission/types'
import { BENEFIT_OPTIONS, IAdmissionStepProps } from '../admissionForm'

interface IBenefitsStepProps extends IAdmissionStepProps {
  /** The term stored with the acceptance, exactly as shown; the panel has no acceptance to give. */
  term?: string
}

/**
 * Vale-Transporte and Auxílio-Combustível go together; "Não opto por nenhum" stands alone. The
 * acceptance belongs to the options chosen, so changing them asks for it again.
 */
export default function BenefitsStep({ form, update, errors, isDisabled, term, mode = 'form' }: IBenefitsStepProps) {
  const required = mode === 'form'
  const toggle = (benefit: TTransportBenefit, checked: boolean) => {
    const others = form.transport_benefits.filter((item) => item !== benefit && item !== 'none')
    const transportBenefits = !checked
      ? form.transport_benefits.filter((item) => item !== benefit)
      : benefit === 'none'
        ? ['none' as const]
        : [...others, benefit]

    update({ transport_benefits: transportBenefits, benefit_accepted: false })
  }

  return (
    <>
      <FormField
        label="Selecione qual opção você deseja"
        error={errors.transport_benefits}
        isRequired={required}
        htmlFor="benefits"
      >
        <Stack id="benefits" spacing={3} mt={1}>
          {BENEFIT_OPTIONS.map((option) => (
            <Flex key={option.value} align="center" gap={2}>
              <Checkbox
                isChecked={form.transport_benefits.includes(option.value)}
                onChange={(e) => toggle(option.value, e.target.checked)}
                isDisabled={isDisabled}
              >
                {option.label}
              </Checkbox>
              {/* Outside the label and focusable: inside it the click would toggle the box. */}
              {option.tooltip && (
                <Tooltip label={option.tooltip}>
                  <Box
                    as="span"
                    tabIndex={0}
                    role="img"
                    aria-label={`Sobre ${option.label}`}
                    display="inline-flex"
                    cursor="help"
                  >
                    <Icon name="lni lni-information" size="sm" color="gray.400" />
                  </Box>
                </Tooltip>
              )}
            </Flex>
          ))}
        </Stack>
      </FormField>

      {form.transport_benefits.includes('fuel_allowance') && (
        <Text variant="caption" mt={3}>
          O Auxílio-Combustível usa o endereço informado em Dados pessoais.
        </Text>
      )}

      {/* The acceptance is the person's own: RH edits the benefits but never accepts for them. */}
      {required && (
        <FormField mt={8} error={errors.benefit_accepted}>
          <Checkbox
            isChecked={form.benefit_accepted}
            onChange={(e) => update({ benefit_accepted: e.target.checked })}
            isDisabled={isDisabled}
            alignItems="flex-start"
          >
            <Text fontSize="sm">{term}</Text>
          </Checkbox>
        </FormField>
      )}
    </>
  )
}
